import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FILETYPE, imgExtensions, audioExtension, videoExtension } from 'src/app/helper/interface/media-interface';

@Component({
  selector: 'doc-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './doc-preview.component.html',
  styleUrls: ['./doc-preview.component.scss']
})
export class DocPreviewComponent implements OnChanges {
  @Input() src: string = '';
  @Input() showDelete: boolean = false;
  @Input() primaryKey: string | number = '';
  @Input() remarks: string = '';
  @Output() onDelete = new EventEmitter<any>();

  fileType: FILETYPE = 'IMAGE';
  fileName: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] && this.src) {
      this.fileType = this.detectFileType(this.src);
      this.fileName = this.src.split('/').pop() || '';
    }
  }

  detectFileType(url: string): FILETYPE {
    const ext = url.split('.').pop()?.toLowerCase() || '';
    if (imgExtensions.includes(ext)) return 'IMAGE';
    if (audioExtension.includes(ext)) return 'AUDIO';
    if (videoExtension.includes(ext)) return 'VIDEO';
    return 'DOCUMENT';
  }

  getDocIcon(): string {
    const ext = this.src.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf': return 'pi pi-file-pdf';
      case 'doc':
      case 'docx': return 'pi pi-file-word';
      case 'xls':
      case 'xlsx': return 'pi pi-file-excel';
      case 'mp3':
      case 'flac':
      case 'wav':
      case 'm4a': return 'pi pi-volume-up';
      case 'mp4':
      case 'avi':
      case 'mkv': return 'pi pi-video';
      default: return 'pi pi-file';
    }
  }

  getDocColor(): string {
    const ext = this.src.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf': return '#e53935';
      case 'doc':
      case 'docx': return '#1565c0';
      case 'xls':
      case 'xlsx': return '#2e7d32';
      case 'mp3':
      case 'flac':
      case 'wav':
      case 'm4a': return '#6a1b9a';
      case 'mp4':
      case 'avi':
      case 'mkv': return '#e65100';
      default: return '#546e7a';
    }
  }

  delete(): void {
    if (confirm('Are you sure you want to remove this file?')) {
      this.onDelete.emit(this.primaryKey);
    }
  }
}
